<script lang="ts">
	interface Props {
		strokeColor?: string;
	}

	let { strokeColor = "black" }: Props = $props();
</script>

<svg width="64" height="54" viewBox="0 0 64 54" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g clip-path="url(#clip0_625_60)">
		<path
			d="M9 32.942C9 32.3454 9.26631 31.78 9.72624 31.4001L30.7262 14.0522C31.4656 13.4415 32.5344 13.4415 33.2738 14.0522L54.2738 31.4001C54.7337 31.78 55 32.3454 55 32.942V52C55 53.1046 54.1046 54 53 54H43.5H39.75C38.6454 54 37.75 53.1046 37.75 52V40C37.75 38.8954 36.8546 38 35.75 38H32H28.25C27.1454 38 26.25 38.8954 26.25 40V52C26.25 53.1046 25.3546 54 24.25 54H20.5H11C9.89543 54 9 53.1046 9 52V32.942Z"
			fill={strokeColor}
			class="svg-fill"
		/>
		<path
			d="M4 29L32.0366 6L46.0183 17.5L49.5137 20.375L53.0092 23.25L60 29"
			stroke={strokeColor}
			stroke-width="8"
			stroke-linecap="round"
			class="svg-stroke"
		/>
		<path
			d="M50 17V8"
			stroke={strokeColor}
			stroke-width="8"
			stroke-linecap="square"
			class="svg-stroke"
		/>
	</g>
	<defs>
		<clipPath id="clip0_625_60">
			<rect width="64" height="54" fill="white" />
		</clipPath>
	</defs>
</svg>

<style>
</style>
